"use client";

import { ReactNode } from "react";

import { CookieManager, CookieManagerProps } from "react-cookie-manager";
import "react-cookie-manager/style.css";
import { Analytics } from "../analytics";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import BugsnagPerformance from "@bugsnag/browser-performance";

export const Providers = ({ children }: { children: ReactNode }) => {
	const cookieManagerConfig: CookieManagerProps = {
		children: <></>,
		cookieKey: "apollofit_cookie_consent",
		displayType: "banner",
		position: "bottom",
		enableFloatingButton: false,
		initialPreferences: {
			Advertising: false,
			Analytics: true,
			Social: false,
		},
		theme: "dark",
	};

	Bugsnag.start({
		apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY || "",
		plugins: [new BugsnagPluginReact()],
	});

	BugsnagPerformance.start({
		apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY || "",
	});

	return (
		<CookieManager {...cookieManagerConfig}>
			<>
				{children}
				<Analytics />
			</>
		</CookieManager>
	);
};
